const _excluded = ["mediaUrl", "mediaAlt", "imageFit", "bordered", "style", "anchor"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import { componentsThemeMap } from '../../componentsThemeMap.js';
import { SectionComponentLayout } from '../../layout/SectionComponentLayout.js';
import { TwoColumnLayout } from '../../layout/TwoColumnLayout.js';
import { AnalyticsProvider } from '../../providers/AnalyticsProvider.js';
import { ErrorBoundary } from '../../ui/ErrorBoundary.js';
import '../../ui/Image/index.js';
import { HeroEditorialContent } from './HeroEditorialContent.js';
import { jsx } from 'react/jsx-runtime';
import { Image } from '../../ui/Image/Image.js';
const DEFAULT_ALT_TEXT = 'Hero image';
function HeroEditorial(_ref) {
  let mediaUrl = _ref.mediaUrl,
    mediaAlt = _ref.mediaAlt,
    imageFit = _ref.imageFit,
    bordered = _ref.bordered,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? 'default' : _ref$style,
    anchor = _ref.anchor,
    contentProps = _objectWithoutProperties(_ref, _excluded);
  const background = componentsThemeMap[style].background;
  const textContent = /*#__PURE__*/jsx(HeroEditorialContent, _objectSpread({
    style: style
  }, contentProps));
  const imageContent = /*#__PURE__*/jsx(Image, {
    priority: true,
    loading: "eager",
    alt: mediaAlt || DEFAULT_ALT_TEXT,
    src: mediaUrl,
    maxHeight: {
      sm: 170,
      md: 353,
      lg: 638
    },
    imageFit: imageFit,
    bordered: bordered
  });
  return /*#__PURE__*/jsx(ErrorBoundary, {
    children: /*#__PURE__*/jsx(AnalyticsProvider, {
      analyticsPrefix: "HeroEditorial",
      children: /*#__PURE__*/jsx(SectionComponentLayout, {
        as: "header",
        hasSpacingHorizontal: true,
        background: background,
        anchor: anchor,
        children: /*#__PURE__*/jsx(TwoColumnLayout, {
          mainContentPosition: "top",
          mainContent: textContent,
          secondaryContent: imageContent,
          gap: mediaUrl ? 4 : 0
        })
      })
    })
  });
}
export { HeroEditorial };
//# sourceMappingURL=HeroEditorial.js.map
